import React, { useState } from "react";
import ResizeListener from "../../../../../utility/ResizeListener";
import { BlackClear } from "../../../../resources/assetsManager";
import {
  BG_COLOR,
  LIGHT_GREY_BG_MODAL,
  WHITE_COLOR,
} from "../../../../resources/colorsManager";
import AddCustomerTabs from "../../add_customer/AddCustomerTabs";
import AddBeneficiaryBulk from "./bulk/AddBeneficiaryBulk";
import AddBeneficaryIndividual from "./individual/AddBeneficaryIndividual";

function AddBeneficiaryModalIndex({ onClose, onSuccess }) {
  const { width, height } = ResizeListener();
  const [step, setStep] = useState(0);
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
        padding: "20px 30px",
        backgroundColor: WHITE_COLOR,
        minWidth: 400,
        borderRadius: 30,
        width: width * 0.35,
        minHeight: height * 0.55,
        height: "100%",
        // alignItems: "center",'
        paddingBottom: 20,
        maxWidth: 400,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            fontSize: 18,
            fontWeight: "600",
            width: "100%",
            textAlign: "center",
          }}
        >
          Add Beneficiary
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: BG_COLOR,
            padding: 10,
            borderRadius: 6,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <img src={BlackClear} />
        </div>
      </div>

      {/* <AddCustomerTabs
        title1="Single upload"
        title2="Bulk upload"
        onClick1={() => {
          setStep(0);
        }}
        onClick2={() => {
          setStep(1);
        }}
        currentStep={step}
        key={step}
        style={{
          margin: "15px 0px",
        }}
      /> */}
      <div
        style={{
          marginBottom: 30,
        }}
      >
        {step === 0 ? (
          <AddBeneficaryIndividual onClose={onClose} onSuccess={onSuccess} />
        ) : step === 1 ? (
          <AddBeneficiaryBulk
            onSuccess={() => {
              onClose();
              onSuccess();
            }}
          />
        ) : null}
      </div>
    </div>
  );
}

export default AddBeneficiaryModalIndex;
